import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"display":"inline"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_parameter_inline = _resolveComponent("parameter-inline")!
  const _component_q_icon = _resolveComponent("q-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_parameter_inline, {
      "is-root": "",
      editable: "",
      "move-to-body": "",
      "use-vendor-code": "",
      "bold-selected": "",
      modelValue: _ctx.innerModel,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.innerModel) = $event)),
      id: _ctx.id,
      "root-param": _ctx.rootParam,
      "context-trigger": _ctx.triggerEl,
      "show-custom": false,
      "maintain-string-value": true
    }, null, 8, ["modelValue", "id", "root-param", "context-trigger"]),
    (_ctx.showClearIcon)
      ? (_openBlock(), _createBlock(_component_q_icon, {
          key: 0,
          name: "arrow_back",
          size: "18px",
          color: "grey-7",
          class: "pointer hover-green q-ml-sm",
          style: {"align-self":"baseline"},
          title: "clear",
          onClick: _ctx.onClear
        }, null, 8, ["onClick"]))
      : _createCommentVNode("", true)
  ]))
}